import React, {useEffect, useState} from 'react';
import './App.css';
import fetchAppData, {AppData} from './fetchAppData';
import RMAForm from './RMAForm';
import {Alert} from "react-bootstrap";
import Footer from "./Footer";

function App() {

    const [data, setData] = useState<AppData|null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    // fetching app data
    useEffect(() => {
        console.log('fetch data');
        fetchAppData()
            .then((appData) => {
                setData(appData)
                setLoading(false)
            })
            .catch((e) => {
                console.error(e)
                setLoading(false)
            })
    }, [])

    const content = (() => {
        if (loading) {
            return <p>Lädt ...</p>
        }

        if (data !== null && loading === false) {
            if (data.failedToLoad) {
                return (
                    <Alert variant="danger" className="m-3">
                        <Alert.Heading>Fehler beim Laden</Alert.Heading>
                        <p>
                            Failed to load Data, please try again later.
                        </p>
                        <p>
                            Daten laden fehlgeschlagen, bitte später nochmal probieren.
                        </p>
                    </Alert>
                )
            }
            return <RMAForm appData={data} />
        }

        return <p>Error</p>
    })();

    return (
        <div className="app-shell">
            <main className="app-main">
                {content}
            </main>
            <Footer />
        </div>
    );
}

export default App;